export default __webpack_public_path__ + "static/curious-5e1d22090f8845aa552b04e48ab77ab3.svg";